/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CompanyModal from './Company.Modal'
import Alert from '../../../adminv2/common/Alert'
import Consultations from '@services/Consultations'
import { history } from '@services/History'
import { useDispatch } from 'react-redux'
import { showAlert } from '../alert/Alert.dux'
import _ from 'lodash'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

export default function CompanyProtocolForm(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const companyClient = Consultations.company

  let company = props.company
  let { formData, setFormData, initialFormData, setInitialFormData } = props

  const [showModal, setShowModal] = useState(false)
  const [requirements, setRequirements] = useState(company?.protocol ? company?.protocol : null)

  useEffect(() => {
    initializeFormData()
  }, [])

  const initializeFormData = () => {
    let formattedPreferedSpecialities = company?.specialities
      ? company.specialities.filter((speciality) => speciality.pivot?.position).map((e) => e.id)
      : []
    let formatedSpecialities = company?.specialities ? company.specialities.map((e) => e.id) : []

    let initial = {
      status: company?.active,
      name: company?.name,
      fiscal_name: company?.fiscal_name,
      support_email: company?.support_email,
      sms_sender_name: company?.sms_sender_name,
      potential: company?.potential,
      objective: company?.objective,
      meeting_type: company?.meeting_type,
      has_video_call: company?.has_video_call,
      has_video_call_1to1: company?.has_video_call_1to1,
      has_medical_reports: company?.has_medical_reports,
      has_medical_derivations: company?.has_medical_derivations,
      has_prescription: company?.has_prescription,
      protocol: company?.protocol ? company.protocol : null,
      //Selects
      sector_id: company?.sector_id,
      areas: company?.areas,
      specialities: formatedSpecialities.filter((element) => !formattedPreferedSpecialities.includes(element)),
    }
    setInitialFormData(initial)
    setFormData(initial)
  }

  const successAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdateSuccessMessage'),
        important: t('goodJob'),
        type: 'success',
      })
    )
  }

  const failureAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdatingErrorMEssage'),
        important: 'Oh snap!',
        type: 'danger',
      })
    )
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }

  const formatData = (params) => {
    let result = {
      ...initialFormData,
      protocol: requirements,
    }
    return result
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let formattedValues = formatData()

    if (company && company.id) {
      companyClient
        .update(company.id, formattedValues)
        .then((res) => successAlertOpening())
        .then((res) => setInitialFormData(formData))
        .catch((err) => {
          failureAlertOpening()
        })
    } else {
      companyClient
        .store(formattedValues)
        .then((res) => successAlertOpening())
        .then((res) => setInitialFormData(formData))
        .catch((err) => {
          failureAlertOpening()
        })
    }
  }

  return (
    <div className="companies-form md-form">
      <Alert timeOut={3000} />
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('welcomeMessage-submit-btn').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/companies')}
        />
      ) : null}
      <form className="protocol-form" onSubmit={handleSubmit} id="protocol-form">
        <h1>{t('mandatoryRequirements')}</h1>
        <ReactQuill
          theme="snow"
          value={requirements}
          readOnly={props.isUpdating}
          onChange={(data, delta, editor, e) => {
            if (e.getText().trim().length > 0) {
              setRequirements(data)
              setFormData({ ...formData, protocol: data })
            } else {
              setRequirements(null)
              setFormData({ ...formData, protocol: null })
            }
          }}
        />
        <div className="companies-form--buttonsContainer">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkUnsavedChanges()}
            id="welcomeMessage-submit-btn"
          >
            {t('Guardar')}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              if (checkUnsavedChanges()) {
                history.push('/companies')
              } else {
                setShowModal(true)
              }
            }}
          >
            {t('Cancelar')}
          </button>
        </div>
      </form>
    </div>
  )
}
